import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, Users, Package, Heart, Activity, Globe } from 'lucide-react';
import { AnimatedCounter } from '../ui/AnimatedCounter';
import { ProgressBar } from '../ui/ProgressBar';
import { EnhancedScrollReveal } from '../common/EnhancedScrollReveal';
import { Badge } from '../ui/Badge';
export function CustomerSuccessDashboard() {
  return <section className="py-24 bg-charcoal-900 text-white overflow-hidden relative" data-id="element-1817">
      {/* Background Map Effect */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-1818">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/World_map_blank_without_borders.svg/2000px-World_map_blank_without_borders.svg.png" alt="World Map" className="w-full h-full object-cover grayscale invert opacity-50" data-id="element-1819" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-900 via-transparent to-charcoal-900" data-id="element-1820" />
      </div>

      <div className="container-custom max-w-7xl mx-auto relative z-10" data-id="element-1821">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8" data-id="element-1822">
          <div className="max-w-2xl" data-id="element-1823">
            <EnhancedScrollReveal data-id="element-1824">
              <div className="flex items-center gap-2 text-xs font-bold text-emerald-400 bg-emerald-400/10 px-3 py-1.5 rounded-full w-fit mb-6 border border-emerald-400/20" data-id="element-1825">
                <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" data-id="element-1826" />
                DASHBOARD EN TIEMPO REAL
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-1827">
                Impacto en la comunidad
              </h2>
              <p className="text-gray-400 text-lg font-light" data-id="element-1828">
                Monitorizando la salud y felicidad de miles de mascotas en toda
                España.
              </p>
            </EnhancedScrollReveal>
          </div>
        </div>

        {/* Main Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1829">
          {[{
          icon: Users,
          label: 'Mascotas Activas',
          val: 52430,
          sub: '+12% este mes',
          color: 'text-blue-400',
          bg: 'bg-blue-400/10'
        }, {
          icon: Package,
          label: 'Raciones Servidas',
          val: 2500000,
          sub: 'Total histórico',
          color: 'text-emerald-400',
          bg: 'bg-emerald-400/10'
        }, {
          icon: Star,
          label: 'Valoración Media',
          val: 4.9,
          sub: '12.5k reseñas',
          color: 'text-amber-400',
          bg: 'bg-amber-400/10',
          isDecimal: true
        }, {
          icon: Activity,
          label: 'Salud Mejorada',
          val: 94,
          sub: '% de reportes positivos',
          color: 'text-rose-400',
          bg: 'bg-rose-400/10',
          suffix: '%'
        }].map((stat, i) => <EnhancedScrollReveal key={i} delay={i * 0.1} data-id="element-1830">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-all duration-300 group" data-id="element-1831">
                <div className="flex items-center justify-between mb-6" data-id="element-1832">
                  <div className={`w-12 h-12 rounded-2xl ${stat.bg} flex items-center justify-center ${stat.color} group-hover:scale-110 transition-transform`} data-id="element-1833">
                    <stat.icon className="w-6 h-6" data-id="element-1834" />
                  </div>
                  <Globe className="w-4 h-4 text-gray-600 group-hover:text-gray-400 transition-colors" data-id="element-1835" />
                </div>
                <div className="text-4xl font-bold mb-2 font-serif tabular-nums" data-id="element-1836">
                  {stat.isDecimal ? stat.val : <AnimatedCounter value={stat.val} data-id="element-1837" />}
                  {stat.suffix}
                </div>
                <div className="text-sm font-bold text-gray-300 mb-1" data-id="element-1838">
                  {stat.label}
                </div>
                <div className="text-xs text-gray-500 font-mono" data-id="element-1839">
                  {stat.sub}
                </div>
              </div>
            </EnhancedScrollReveal>)}
        </div>

        {/* Split Section: Metrics & Live Feed */}
        <div className="grid lg:grid-cols-2 gap-8" data-id="element-1840">
          {/* Satisfaction Metrics */}
          <EnhancedScrollReveal delay={0.4} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-[2.5rem] p-8 md:p-10" data-id="element-1841">
            <h3 className="text-xl font-bold mb-8 flex items-center gap-3" data-id="element-1842">
              <Heart className="w-6 h-6 text-rose-500" data-id="element-1843" />
              Métricas de Satisfacción
            </h3>
            <div className="space-y-8" data-id="element-1844">
              {[{
              label: 'Recomendaría a un amigo',
              val: 98,
              color: 'bg-emerald-500'
            }, {
              label: 'Mejora visible en vitalidad',
              val: 94,
              color: 'bg-blue-500'
            }, {
              label: 'Aceptación del sabor (Palatabilidad)',
              val: 99,
              color: 'bg-amber-500'
            }].map((metric, i) => <div key={i} data-id="element-1845">
                  <div className="flex justify-between text-sm mb-3" data-id="element-1846">
                    <span className="text-gray-300 font-medium" data-id="element-1847">
                      {metric.label}
                    </span>
                    <span className="font-bold text-white" data-id="element-1848">{metric.val}%</span>
                  </div>
                  <div className="h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-1849">
                    <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${metric.val}%`
                }} transition={{
                  duration: 1.5,
                  delay: 0.5 + i * 0.2
                }} className={`h-full rounded-full ${metric.color}`} data-id="element-1850" />
                  </div>
                </div>)}
            </div>
          </EnhancedScrollReveal>

          {/* Live Activity Feed */}
          <EnhancedScrollReveal delay={0.5} className="bg-gradient-to-br from-charcoal-800 to-charcoal-900 border border-white/10 rounded-[2.5rem] p-8 md:p-10 relative overflow-hidden" data-id="element-1851">
            <div className="absolute top-0 right-0 p-6" data-id="element-1852">
              <div className="flex gap-1" data-id="element-1853">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-1854" />
                <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse delay-75" data-id="element-1855" />
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse delay-150" data-id="element-1856" />
              </div>
            </div>

            <h3 className="text-xl font-bold mb-8" data-id="element-1857">Actividad Reciente</h3>

            <div className="space-y-6 relative" data-id="element-1858">
              {/* Gradient mask for fade out at bottom */}
              <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-charcoal-900 to-transparent z-10" data-id="element-1859" />

              {[{
              name: 'María R.',
              loc: 'Madrid',
              action: 'Plan Personalizado',
              time: '2m',
              avatar: 'MR'
            }, {
              name: 'Juan L.',
              loc: 'Barcelona',
              action: 'Pack Degustación',
              time: '5m',
              avatar: 'JL'
            }, {
              name: 'Carmen P.',
              loc: 'Valencia',
              action: 'Suscripción Senior',
              time: '12m',
              avatar: 'CP'
            }, {
              name: 'Roberto S.',
              loc: 'Sevilla',
              action: 'Juguete Interactivo',
              time: '15m',
              avatar: 'RS'
            }].map((item, i) => <div key={i} className="flex items-center gap-4 animate-fade-in" style={{
              animationDelay: `${i * 1000}ms`
            }} data-id="element-1860">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold text-white border border-white/5" data-id="element-1861">
                    {item.avatar}
                  </div>
                  <div className="flex-1" data-id="element-1862">
                    <div className="text-sm text-gray-300" data-id="element-1863">
                      <span className="font-bold text-white" data-id="element-1864">{item.name}</span>{' '}
                      de {item.loc}
                    </div>
                    <div className="text-xs text-primary-400 font-medium" data-id="element-1865">
                      {item.action}
                    </div>
                  </div>
                  <div className="text-xs text-gray-600 font-mono" data-id="element-1866">
                    {item.time}
                  </div>
                </div>)}
            </div>
          </EnhancedScrollReveal>
        </div>
      </div>
    </section>;
}